// eslint-disable-next-line
export const SUCCESS_MESSAGES = {
  userAddSaveSuccessMessage(firstName, lastName) {
    return `Obchodník ${firstName} ${lastName} byl založen.`;
  },
  userEditSaveSuccessMessage(firstName, lastName) {
    return `Obchodník ${firstName} ${lastName} byl upraven.`;
  },
  userDeleteSuccessMessage(firstName, lastName) {
    return `Obchodník ${firstName} ${lastName} byl odstraněn.`;
  },
  SEND_REQUEST_SUCCESS_MESSAGE: 'Požadavek byl úspěšně odeslán.',
};
